// extracted by mini-css-extract-plugin
module.exports = {"background":"styles_background__WOgWr","image":"styles_image__BHa_3","video":"styles_video__nEYzm"};